import { cn } from "@/lib/utils";
import { Link } from "@/i18n/navigation";
import { LinkProps } from "next/link";

type LinkTarget = "_blank" | "_self" | "_parent" | "_top";

interface PropsType extends LinkProps {
  children: React.ReactNode;
  className?: string;
  target?: LinkTarget;
  rel?: string;
  linkProps?: LinkProps;
  onClick?: () => void;
}

function FooterLink({ children, className, href, rel, target, onClick }: PropsType) {
  return (
    <Link
      className={cn(
        "group flex items-center gap-4 text-foreground-light transition-all hover:text-primary hover:underline hover:underline-offset-4 dark:text-primary-foreground dark:opacity-80",
        className,
      )}
      href={href}
      rel={rel}
      target={target}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}

export default FooterLink;
